import styles from './PlaceHolder.module.scss';

interface RestProps {
  [x: string]: any;
}
interface IPlaceholder {
  children?: React.ReactNode;
  height: string | number;
}

export const PlaceHolder = ({ children, height, ...restProps }: IPlaceholder & RestProps) => {
  return (
    <div className={`${styles.PlaceHolder} ${restProps.className || ''}`} style={{ height }}>
      {children}
    </div>
  );
};
